import { render, staticRenderFns } from "./super_admin.htm?vue&type=template&id=747163fb&external"
import script from "./super_admin.vue?vue&type=script&lang=js"
export * from "./super_admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports